
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectpropertyManagerDetails, selectAuthenticatedUser } from '../../store/selectors/auth';
import { fetchPropertyDetailsByProperty, clearPropertyManagerDetails } from '../../store/actions/auth';
import { fetchUserSuites, setCurrentUserSuite } from '../../store/actions/userSuites';
import { selectCurrentUserSuite, selectUserSuiteList } from '../../store/selectors/userSuites';
import HomeOwnerDashboard from '../../components/HomeOwnerDashboard/HomeOwnerDashboard';
import HomeOwnerOnboardingDashboard from '../../components/HomeOwnerDashboard/HomeOwnerOnboardingDashboard/HomeOwnerOnboardingDashboard/HomeOwnerOnboardingDashboard';
import { clearOrderDetails, clearOrders, fetchOnboardingOrderDetails, onFetchOnboardingOrders } from '../../store/actions/HomeOwnerOnboardingDashboard';
import Loader from '../../components/Loader';
import { fetchtAllowedTabList } from '../../store/actions/tabSelections';
import { store } from '../../store';

class HomeOwnerDashboardvsOnboardingDashboard extends Component {

    async componentDidMount() {
        const { user, onFetchPropertyManagerDetails,
            onFetchUserSuites, loader, currentUserSuite, userSuiteList, fetchtAllowedTabList, onFetchOnboardingOrders } = this.props
        let currentpropertyId = (userSuiteList && userSuiteList.length > 0 && userSuiteList[0].propertyId) ? userSuiteList[0].propertyId : currentUserSuite.propertyId
        onFetchUserSuites(user.id, loader, user.roles[0].role.name);
        onFetchPropertyManagerDetails(currentpropertyId);
        fetchtAllowedTabList(currentpropertyId);
        setTimeout(()=>{

            const {orders}= store.getState().onboardingData;
            const showHomeownerDasboard = Object.keys(orders).length > 0 ?true :false;
            let filteredOrderPostOccupied = Object.keys(orders).length > 0? orders.filter((order) => order.isPostOccupancy === true):{}
            let filteredOrderPreOccupied = Object.keys(orders).length > 0? orders.filter((order) => order.isPostOccupancy === false):{}
           // if((currentUserSuite.status === 'Occupied' && Object.keys(filteredOrderPostOccupied).length === 0) || (currentUserSuite.status !== 'Occupied' && Object.keys(filteredOrderPreOccupied).length === 0)){
            if(showHomeownerDasboard === false && user.isDashboardAccess===false){   
            
           if(currentUserSuite.propertyId !== undefined && currentUserSuite.id !== undefined){
                    let link=`/app/suites/${currentUserSuite.propertyId}&${currentUserSuite.id}`
                    this.props.history.push(
                     { pathname:link,
                      state: {
                        suite: { id: currentUserSuite.id },
                        property: {
                          id: currentUserSuite.propertyId,
                        },
                        activeTab: 0,
                        from: "Dashboard",
                      },}
                    )
                }}
        },3000)
    }

    async componentDidUpdate(prevProps) {
        const { currentUserSuite: prevCurrentUserSuite } = prevProps
        const { currentUserSuite, fetchtAllowedTabList } = this.props
        if (prevCurrentUserSuite.id !== currentUserSuite.id) {            
            const { onFetchPropertyManagerDetails, currentUserSuite,onboardingData,onFetchOnboardingOrderDetails, user, onFetchOnboardingOrders  } = this.props
            onFetchPropertyManagerDetails(currentUserSuite.propertyId);
            fetchtAllowedTabList(currentUserSuite.propertyId);
            onFetchOnboardingOrders(currentUserSuite.propertyId, currentUserSuite.id, user.id);
            setTimeout(()=>{

                const {orders}= store.getState().onboardingData;
                const showHomeownerDasboard = Object.keys(orders).length > 0 ?true :false;
                let filteredOrderPostOccupied = Object.keys(orders).length > 0? orders.filter((order) => order.isPostOccupancy === true):{}
                let filteredOrderPreOccupied = Object.keys(orders).length > 0? orders.filter((order) => order.isPostOccupancy === false):{}
                //if((currentUserSuite.status === 'Occupied' && Object.keys(filteredOrderPostOccupied).length === 0) || (currentUserSuite.status !== 'Occupied' && Object.keys(filteredOrderPreOccupied).length === 0)){
                if(showHomeownerDasboard === false && user.isDashboardAccess===false){ 
                
                if(currentUserSuite.propertyId !== undefined && currentUserSuite.id !== undefined){
                        let link=`/app/suites/${currentUserSuite.propertyId}&${currentUserSuite.id}`
                        this.props.history.push(
                         { pathname:link,
                          state: {
                            suite: { id: currentUserSuite.id },
                            property: {
                              id: currentUserSuite.propertyId,
                            },
                            activeTab: 0,
                            from: "Dashboard",
                          },}
                        )
                    }}
            },3000)

        }
    }
    render() {
        const { propertyManagerDetails, history, currentUserSuite, onboardingData, onClick, onChange , user } = this.props;
        //const showHomeownerDasboard = (currentUserSuite && currentUserSuite.status === 'Occupied' || currentUserSuite && currentUserSuite.status !== 'Occupied' && onboardingData.orders.length === 0);
        const {orders}= store.getState().onboardingData;
        const showHomeownerDasboard = Object.keys(orders).length > 0 ?true :false;
        return (
            !showHomeownerDasboard && user.isDashboardAccess===false?<Loader center={true}/>:
            <div className='homeDasboard'>
                {
                    propertyManagerDetails && propertyManagerDetails.propertyName ?
                        <>
                            <>
                            {((onboardingData && onboardingData.fetchOrdersLoading === true) || (onboardingData && onboardingData.fetchDetailsLoading === true)) && <Loader center={true}/>}
                        
                           { showHomeownerDasboard || user.isDashboardAccess===true ?
                            <HomeOwnerOnboardingDashboard
                                        currentUserSuite={currentUserSuite}
                                        history={history}
                                    />:<Loader center={true}/>
                                }
                            </>
                        </>
                        : null}
            </div>
        );
    };
}
const mapStateToProps = (state) => ({
    user: selectAuthenticatedUser(state),
    propertyManagerDetails: selectpropertyManagerDetails(state),
    currentUserSuite: selectCurrentUserSuite(state),
    userSuiteList: selectUserSuiteList(state),
    onboardingData: state.onboardingData
})

const maptDispatchToProps = dispatch => bindActionCreators({
    onFetchUserSuites: fetchUserSuites,
    onFetchPropertyManagerDetails: fetchPropertyDetailsByProperty,
    clearPropertyManagerDetails: clearPropertyManagerDetails,
    onCurrentSuiteChange: setCurrentUserSuite,
    clearOrderDetails: clearOrderDetails,
    clearOrders: clearOrders,
    onFetchOnboardingOrders: onFetchOnboardingOrders,
    fetchtAllowedTabList,
    onFetchOnboardingOrderDetails: fetchOnboardingOrderDetails,
}, dispatch)
export default connect(mapStateToProps, maptDispatchToProps)(HomeOwnerDashboardvsOnboardingDashboard);
